import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { ThemeProvider, CorezoidLightTheme } from 'mw-style-react';
import smoothscroll from 'smoothscroll-polyfill';
// import {withPrefix} from 'gatsby-link';
import Header from '../Header';
import Footer from '../Footer';
import Utils from '../../utils/utils';
import '../../styles/core.scss';
import '../../styles/theme.scss';
import './Layout.scss';
// import { languages } from '../../../src/i18n/locales';
import titlesAndDescription from '../../constants/titlesAndDescription';
import mainLogo from '../../images/corezoid-logo-2.png';
// import { logo } from '../../images';

class Layout extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isScrolled: false,
    };

    this.refLayout = null;
  }
  url = '';

  componentDidMount() {
    smoothscroll.polyfill();
    if (typeof window !== 'undefined') {
      window.__forceSmoothScrollPolyfill__ = true;
      window.scrollTo({
        top: 0
      });

      this.url = window.location.href;
      if (location.href.indexOf('/ru/') !== -1) {
        const url = location.href.replace('/ru/', '/');
        Utils.addTag('link',
          {
            rel: 'alternate',
            href: location.href,
            hreflang: 'ru'
          }
        );
        Utils.addTag('link',
          {
            rel: 'alternate',
            href: url,
            hreflang: 'en'
          }
        );
      }
    }
  }

  componentWillUnmount() {
    Utils.removeTags({
      tag: 'link',
      rel: 'alternate'
    });
  }

  _handleScroll() {
    const { isScrolled } = this.state;
    if (this.refLayout.scrollTop > 0 && !isScrolled) {
      this.setState({
        isScrolled: true
      });
    } else if (this.refLayout.scrollTop === 0 && isScrolled) {
      this.setState({
        isScrolled: false
      });
    }
  }

  render() {
    const { page, children, location = {}, intl } = this.props;
    const { pathname, href } = location;
    const { isScrolled } = this.state;
    const lacation = this.props.pageContext && this.props.pageContext.originalPath;
    const mainHeader = lacation === '/';
    const locale = intl && intl.locale || 'en';

    const metadata = Utils.getDataWithFallback(titlesAndDescription, pathname);

    return (
      <ThemeProvider theme={CorezoidLightTheme}>
        <div
          onScroll={this._handleScroll.bind(this)}
        >
          <div className="layout__header">
            <Header
              page={page}
              isScrolled={isScrolled}
              mainHeader={mainHeader && !isScrolled}
            />
          </div>
          <div
            className="layout"
            ref={el => (this.refLayout = el)}
          >
            <Helmet>
              <html lang={locale} />
              <link rel="preconnect" href="https://fonts.googleapis.com" />
              <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
              <link rel="preload" as="style" href="https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,600;0,700;0,800;1,300&family=PT+Sans&display=swap" />
              <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,600;0,700;0,800;1,300&family=PT+Sans&display=swap" media="print" onLoad="this.media='all'" />
              <noscript>{'<link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,600;0,700;0,800;1,300&family=PT+Sans&display=swap">'}</noscript>
              <link rel="dns-prefetch" href="https://www.googletagmanager.com" />
              <link rel="dns-prefetch" href="https://static.hotjar.com" />
              <link rel="dns-prefetch" href="https://www.google-analytics.com" />
              <link rel="dns-prefetch" href="https://dev-posthog-i.corezoid.com" />
              <meta property="og:image" content={`https://corezoid.com${mainLogo}`} />
              <meta property="og:title" content={metadata.title} />
              <meta property="og:description" content={metadata.description} />
              <meta property="og:url" content={href} />
              <meta property="og:type" content="website" />
              <meta property="og:site_name" content="Corezoid" />
              <title>
                {metadata.title}
              </title>
              <meta
                name="msvalidate.01"
                content="0797F619DCE97D327363AE48DFF5820A"
              />
              <meta
                name="description"
                content={metadata.description}
              />
              {process.env.GATSBY_BUILD_ENV === 'production' && (
                <meta
                  name="google-site-verification"
                  content="MqXV4BaLGUW4FwNBRc91D_5-RFZfoh3fwaZz9OVUdPE"
                />
              )}
            </Helmet>
            <div className="layout__content">
               {children}
            </div>
            {/* <Link className="layout__online" to={'https://whereby.com/corezoid'}>*/}
            {/*   <div className="layout__online__btn"><Image file={'video-icon.png'}/></div>*/}
            {/*   <div className="layout__online__text">Corezoid Cafe</div>*/}
            {/* </Link>*/}
            <div className="layout__footer">
              <Footer/>
            </div>
          </div>
        </div>
      </ThemeProvider>
    );
  }
}

Layout.defaultProps = {
  page: '',
};

Layout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  pageContext: PropTypes.object,
  page: PropTypes.string,
  location: PropTypes.object,
  intl: PropTypes.object
};

export default Layout;
